import { postFetch } from '../fetch';
import { apiConfig } from '../config';

type GptMessage<T extends 'assistant' | 'user' = 'assistant' | 'user'> = {
    role: T;
    text: string;
};

interface GptAnswer {
    alternatives: {
        message: GptMessage<'assistant'>;
        status: 'ALTERNATIVE_STATUS_FINAL';
    }[];
}

export function postGptAnswer(messages: GptMessage[]): Promise<GptAnswer> {
    const { apiPostGptAnswer } = apiConfig.getStaticUrls();

    return postFetch(apiPostGptAnswer, { messages });
}
